var _linearGradient, _linearGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanHostingChipOptimized(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 959,
    height: 593,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(.5473 0 0 .54758 198.87 156.974)"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5e34b2",
      stopOpacity: 1
    },
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b49be4",
      stopOpacity: 1
    },
    offset: 0
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 78.441,
    y1: 309.871,
    x2: 507.033,
    y2: 309.871,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "c",
    x1: 75.941,
    y1: 309.871,
    x2: 509.533,
    y2: 309.871,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#333",
      fillOpacity: 0,
      stroke: "#ccc",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#333",
      fillOpacity: 0,
      stroke: "#ccc",
      strokeWidth: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    className: "al",
    d: "M88.5 5.2V6l1.2.6V5.2Zm5.4 1.3-1.9.6 1.5 4.9-1.3.1 1 3 1.2-2.5.9.8v3.3l-1.2-.3V19l-1.4-3.2h-.9l-.6 4.1-2.7 3 1.9 2.6-.5 3 1.5 1.2v1.2h1.5l.4-1.9-1.4-2.3L91 28l.3-1.8-.2-2.4-1.5-.5 1.8-1.3 1 .8.7-.4-.9-1.1.2-2 .6 1.6 1.6 1.7-.3 1.6-.3-.7-1.8.1-.3 2.3.6.5.6 1.9.6-.1-.7-2.9.8-.9.1 3.5 1.2 1.4-.3 1.4-1-.1-2.3 2.2-.2 2.4-1.4.8.7 2.1-.9-.3.1 2.7-.2 2.9h-1.3l-.1 1.2-.7.3-.3-.9-.8-.6-.2 1.2-2 1.9-.6.1-.7.8h-.7l-.7-1.8-.5 1-.4-1.4-1 1.8.2-2.2-2.2.6 1.3-1.2 2.1.4.6-.4-.1-2.2 1.2-1.2.2 1.1-.8 1.1.1 2 .8-.9.7-2.2.8-.7.8.5-.9 1.1.2 1.4 1 .2.1-1.8.9-1 1-1.9-.1-2-.7.5h-1.3l.9-1.1-.7-.6.8-.8.3 1.6.7-.7v-1.7l-.3-1.1 1.1.9.6-.8h1.5l-.1-4h-1.1v1.4l-3 2.3-1 1.6-1.9.2-1.8.8-2.6 2.8v.6l3.9-.5-.5.9-2.4.2h-2.2l.1-1 2.1-2.2.4-1 3.8-2.8.4-2.1 1.6-.4-1.2 3.4 2.5-2.9.8-.7.1-1.5-.4-1.4 1.1.8.4-2.6h-1.1l-.7 1.5-.1-1.6 1.1-.6-.5-.7-1.4.2-.5 2.6-.6-2.7h-.7l-1 1.6-.2-3-3.2.1-5.1-2.5-4.7-1.9-7.8-7.6-.9-.1-.2.6.7 1.4-2 2.3-.4 2.7-.1 4 1.4 2.1.5 2-.9 6.1.2 3.6.3 4.6-1.2 3.1 1.4-1.6 1.7 1.9 2.2 1.2h-3.2l-.6 1.6-.9-.5-.2-1.5-.2 4.2 1.5.4 1-.3 1.1 2-1.8-.4-1.2 4.2.5 2.2-1.1-2.3-.8.2v2l-.5-.5.7-6-2.5 7.5 1.6.3.7 1.5 2 .1 1.2-.4 2.1 1.5-1.1 1.3-1.5-.2-.5-1.1-1-.1-.7.6-2-1.9v4.3l-1.3 1.3-1.1 3.5-.1 2.3-4.5 12.3L38 114.5l-3.2 4.6-1.6-.1.1 2.1-5.2 7.1-.3 3.3 1 1.3.1 2.4-1.2 1.1-1.2 3 .1 5.7 1.2 2.9-.9 2.5-.1 8.4-4 9.2.1 1.4-1.7 2.4-6.9 7.5-.3 5.2 5.5 11.1-.2 6.4-2.3 3.6-.8 10.7 6.5 12.8 1.1 3.9-.7 5.6 5.4 6.1.9.1.8-1-.5-1.3 1.5-3.8 1.4-.5 1.9 3-2.8 1.5 1 1.7-.5 1.1 1.4 3.4v4.7l-3.7-3.2v-2.5l.8-.7.1-1.6-2.5-.2-.2 2.1-1.2 4.2v7.5l1.5 3.5 2.5 3.3h2.5l1 .9.4 3.2-1.8 3.1-2.4.8-.6 7.1 2.9 2.7 2 5-.2 2.5 1.6 2.3.4 3 2.7 3.7 4 9.4 1.4 1.6-1.8 5.1-.8 4.8-.2 2.8 2.5 2.5 2.8.3 4.7 1.5 3.1 2.3 3.7.5 2.7 2.2 4.5 6.6 1.5 1.9 2.8 1.3 3.9.6 2.2 1.2.7 3.7-1.1 1.8 2 1.9 3.6-.1 7 8.6.6 1.5 1.2 1.4 1.8 4.8.4 7.9-.2 3 1 3 44 5.1-2 1.8-.5 2.9 64.2 37.5 37.3 5.4 15.7 2.2 1.4-10.2 30.8 4.1 2.4 1 1.7 3.7 1.3 1.4-.2 1.2 2.1 1.8 3 1.3 3.2 4.4 2.6 2.3.6 2.1 2.9 1.8v1.1l1.9 1.6.9.1 2.4 1.7.7 1.1 1.2.2v1l1.6 1.6.6 4.2 2.6 4.1.1 2.4-.8 1.5.7 1.3-.2 1.6 2.3 4 .1 2 3.4 3.1 1 .1 1.6 1.2-.2.8 3.4 3.4 2.1.8 1.3.2 1.7 2.3 3.6.5 2 2.9h1l1.8 1.5 2.9-.1.1-1.8 1.3-.6.9-1.6 1.1-.1 1.4-1.2 1.1-4.4 2-3.2 1.7-2.8 3.3-1.2 2.2.6 1.3-1.9 4.2 2.1h4.6l2.6 1.1h2.2l1.3-1.1.7.6h.8l2.1 2.8.8.2v.7l1.2.4.1 1.8 3.3 1.7v1.1l5.1 4.8 1.8 3.1.1 1.7 2.7 4.9-.1 2.1 2 2.2-.1.7 1.4 1.5-.5.7-.2 1.6 1 .7.2 2.1 2.9 2.5 2 1.6.9 2.4.8.2.8 1.7-.1 1.9 4 3.5h1.1l1.7 1.4.8 3.2-.7 3 1.3 1.4.3 2.2-.6 2.6 1.4.6v1.6l1.7 1.4 1.1 1.7.9 4.7 1.4 1.8v1.3l5.4 1.6 3.2 2.6 2.1-.1 1.7 1 3.6 3 2.8.8h7.1l2.3.6 3.4 3.7 1.4.2.9.3-.2-1.4 1.6-1.4 2.2.2.1-.7-2.2-2.6-1.1-2.1v-2.6l-.8-1.7-1.1-.4-.4-1.5 1-.4.4-2.2-.6-3.1-1.6-1.4v-3.1l1.3-.9-.3-1.4-.2-1.2 1.1.1.4-3.2-1.9.6-1.8-.6 2.9-.4 1.4-1 1-1.7.3-2.8 1.8-3.5-1-.8-1.3-.8-.3-1.4 1.8-1.1 1.6.6 1.6-.7 1.8-3.3.4-1.7.8-.7 1.5-.2 2.7-2-.5-1.1.5-2.1 1.2 1.2 1.7-.1 3.9-1.7.7-.8-1.8-1.6-1.2-.9-1.4-.7-.8-2.2h1.5l.3 1.7 1.8 1.2 2.6-1.3 1.1-1.5 1.5.1.2 1.8-.6.8v1.1l-3.2 3 4.1-2.5 4.5-1.9 3.7-2 5-3 3.2-1.4 4-3.9 4.9-4 2.3-1.6v-.8l-1.3-.3-3.3-3.4-.3-1.7 1.9-2.6 2.4-1.3h.6l.9 1.8-.8 2 .7.8 2.9.1-.5.9-1.8.7-2.1 2.3.7.5 1.8-1.8 3.5-1.4 8.4-3.9 3.5-.3 1.6-1.3 5.3-.9 6.1-.1 9.6 3.8 8 1 1.5-1.4 1.8-.2 4.8 2.2 1.6-.4 1.1-1.5-4.2-1.8-2.2 1-1.1-.2-1.4-2 3.3-2.2 1.6-.1v1.7l1.5-.1 3.4-.3.4 2.3 1.1.4.6 1.9 4.8 1 1.7 1.6v.7h-1.2l-1.5 1.7 1.7 1.2 5.4 1 2.7 2.8 4.4-1-3.7.2-.1-.6 2.8-.7.2-1.8 1.2-.3V494l1.1.1v1.6l2.5.1.8-1.9.9.3.2 2.5 1.2.2-1.8 2 2.6-.9 2-1.1 2.9-3.3h-.7l-1.3 1.2-.4-.1-.5-.8.9-1.2v-2.3l1.1-.8.7.7 1-.8 1-.1.6 1.3-.6 1.9h2.4l5.1 1.7.5 1.3 1.6 1.4 2.8.1 1.3.7 1.8-1 .9-1.7v-1.7h-1.4L613 492l-1.1-1.1-3.2-.9-2.6.2-4.2-2.4v-2.3l1.3-1 2.4.6-3.1-1.6.2-.8h3.6l2.6-3.5-2.6-1.8.8-1.5-1.2-.8h-.8l-2 2.1v2.1l-.6.7-1.1-.1-1.6-1.4h-1.3V477l.6-.7.8.7 1.7-1.6.7-1.6.8-.3.7.1 2.6-2.7.6-.1.1-1.6.5-.2.9.7 7.9-2.5 2.4 1.5 5-.1 1.5-1.3.9-.5 1.3.1.6.4.8-.1 2-3.8v-2.3l1.1-1.1 1.4.5 3.4 6.4v.9l-3.3 2.2 3.5-.4 4.9-1.6.5.4 1-.3.7-.8 10.5-2.7 9.2-.5 8.1 1.9 8.5 5 2.4.8 2.2 2-.1 2.7h2.4l1.9-1 2.5.1 2-.8 2.9-2 3.1-2.9 1.1-.4.6.5h1.4l.5-.8-.5-1.2-.6-.6.2-.8 2-1.1 5-.4.8 1 1 .1 2.3 1 3 1.8 1.2 1.7 1.1 1.2 2.8 1.4v2.4l2.8 1.9 1 .1 1.6 1.4.7 1.6 1 .2.8 2.1.7.6 1-1.1 2.9.1.5 1.4 1.1.9v1.3l2.9 2.2.2 9.6-1.8 5.8 1 1.2-.2 3.4-.8 1.4.7 1.2 2.3 2.3.3 1.5.8 1-.4-1.9 1.3-.6.8-3.6-3-1.2.1-.6 2.6-.4.9 2.6 1.1.6.1-2 1.1.3.6.8-.1.7-2.9 4.2-.2 1.1-1.7 1.9v1.1l3.7 3.8 5.3 7.9 1.8 2.1v1.8l2.8 4.6 2.3.6.7-1.2-2.1.3-3-4.5.2-1.4 1.5-.8v-1.5l-.6-1.3.9-.9.4.9.7.5v4l-1.2-.6-.8.9 1.4 1.6 1 2.6 1.2-.6 2.3 1.2 2.1 2.2 1.6 5.1 3.1 4.8.8-1.3 2.8-.5 3.2 1.3.3 1.7 3.3 3.8.1 1.1 2.2 2.7-.7.5v2.7l2.7 1.4h1.5l2.7-1.8 1.5.3 1.1.4 2.3-1.7.2-.7 1.2.3 2.4-1.7 1.3-2.3-.7-3.2-.2-1.3 1.1-4 .6-.2.6 1.6.8-1.8-.8-7.2-.4-10.5-1-6.8-.7-1.7-6.6-11.1-5.2-9.1-2.2-3.3-1.3-3.6-.2-3.4.9-.3v-.9l-1.1-2.2-4-4-7.6-9.7-5.7-10.4-4.3-10.7-.6-3.7-1.2-1-.5-3.8-.7-5.1-.5-2 2.3-6.2.6-6 .9-1.1v-2l-1.5-.5 1.2-.2 4.2-6.2v-1.4l-.9-.4.8-1.5h.6l1.8-1.5.5-2 3.2-2.1.3-2.4-1.2-.9.8-.7.8.4 1.3-.4 1.8-2.1 3.8-1.8 1.6-2.4.1-.7 4.8-4.4-.1-.5-.9-.8 1.1-1.5h.8l.4.5.7-.8h1.3l.6-1.5 2.3-2.1-.3-5.4.8-2.3 3.6-6.2 2.4-2.2 2.2-1.1 4-2.2 3-.7h1.7l1.1 1.1.8-2 .6-5 1.7-3.9 5.4-6.1 4.1-3.5 5.4-2.3 2.5-.4 1.3.4.7 1.1 3.3-6.6 3.3-5.3-.7-.3-4.4 6.8-.5-.8 2-2.2-.4-1.5-2-.5 1 1.3-1.2.1-1.2-1.8-1.2 2-1.6.2 1-2.7.7-1.7-.2-2.9-2.2-.1.9-.9 1.1.3 2.7.1.8-.5h2.3l2-1.9.2-3.2 1.3-1.4 1.2-.2 1.3-1-.5-3.7-2.2-3.8-2.7-.2-.9 1.6-.5-1-2.7.2-1.2.4-1.9 1.2-.3-.4h-.9l-1.8 1.2-2.6.5v-1.3l.8-1 1 .7h1l1.7-2.1 3.7-1.7 2-2.2h2.4l.8 1.3 1.7.8-.5-1.5-.3-1.6-2.8-3.1-.3-1.4-.4 1-.9-1.3-1.3-1.6-.6-1.2.4-.1.9.9-.1-1.4-.3-1.9 1.6 1.2.9 2.1v-1.3l-3.4-5.5v-1.2l-.7-.8-1.3.7.5 1.4h-.8l-.4-1-.6.9-.9-1.1-2.1-.1-.2.7 1.5 2.1-1.4-.7-.5-1-.4.8-.8.1-1.5 1.7.3-1.6v-1.4l-1.5-.7-1.8-.5-.2-1.7-.6-1.3-.6 1.1-1.7-1-2 .3.2-.9 1.5-.2.9.5 1.7-.8.9.4.5 1v.7l1.9.4.3.9.9.4.9 1.2 1.4-1.6h.6l-.1-2.1-1.3 1-.6-.9 1.5-.2-1.2-.9-1.2.6-.1-1.7-1.7.2-2.2-1.1-1.8-2.2 3.6 2.2.9.3 1.7-.8-1.7-.9.6-.6-1-.5.8-.2-.3-.9 1.1.9.4-.8.4 1.3 1.2.8.6-.5-.5-.6-.1-2.5-1.1-.1-1.6-.8.9-1.1-2-.1-.4-.5-1.4.6-1.4-.8-.5-1.2-2.1-1.2-2.1-1.8-2.2-1.9 3 1.3.9 1.2 2.1.7 2.3 2.5.2-1.7.6 1.3 2.3.5v-4l-.8-1.1 1.1.4.1-1.6-3.1-1.4-1.6-.2-1.3-.2.3-1.2-1.5-.3-.1-.6h-1.8l-.2.8-.7-1h-2.7l-1-.4-.2-1-1.2-.6-.4-1.5-.6-.4-.7 1.1-.9.2-.9.7h-1.5l-.9-1.3.4-3.1.5-2.4.6.5.3.5-.8 2.1.4 2.3 1.1.8 1.6-1.3.8-.7.6.2 1 1.3 1 1 1.7.8.4-.2 1.2.3 1-.5 1.4.3 1.7 1.4 1.2.2.4-.2 1.5 1.2h.7v-1l-.4-1.4-1.6-2-.4-2.8-1.6-1.4-1.3-1.4-.7-3.4-.9-1.1.5-1.3v-2.1l.5-1.3-.5-.3 1.1-1-.9-1.2.2-.7-1.3-1.3-1.3-.6 1.8-.5.6-2.2.7-.9.9.4 2.6-3.6-1-1.3.8-1.1 1.5-.4-.2 2.1.3.7-.5.6.5.8-1.4.2-1.1 1.4-1.1 2.4.2 1.7.9 2.1 1-1 .4 1.7-1.2.7-.9-.9-.9 1-.2 2.4.6 1 1-1.4.9-1.1 1 .9-.1 1.6-.8-.7-1 1-.1 3.4.6-.3.4-1.1 1.3.1.1.7 1.4.6-1.7.3-.6 1v.9l1 .6-1.5.8 1.4 1.7 1 1.1.2 1.2 2 1 1.1-.5.7-.6-.5-.8.7-1.6.8.6-.4 1.3.7.8 1.9.4-1.2.3v2l1.6-1-.2 1.5.8.5-.4.7.3 2.5 1.3-.6.4-.9 1.3-.2-.4.9.7.3-.2 1.9-.5-.5-1.3 1 1 .4-1.8 4.4.1 8.1 1.9 3.1.5-1.5.4-2.7-.3-2.3.7-.9-.2-1.4 1.2-.6-.6-.5.5-.7.8 1.1-.2 1.1-.4 3.9 1.1-2.2.4-3.1.1-3-.3-2 .6-2.3 1.1-1.8.1-2.2.3-.9.3-1.1.8-1.4.2-2.1.7-.9.6.6-.1 2.5-1.2 2.2-1.1 2.8.5 1.1.4-1.1.8-3.1 1-1.8.1-3.1v-5.3l-2.2-7.6-1.1.5-3.3-2.6-.5-1.7-1.8-1-.2-3.7-2.1-2.2-1.1-.8-1.2-1.1-.4-3.2.8.9.4 2.3 1.2.6 2.4 1.5 1.8.8 1.6.8.1 1.1.8.1 1.1-1.2.8.4 2.1.2-.2 2.9.2 2.5 1.8-.7 1.5-3.9 1.6-4.8 2.9-2.8.6-3.5-.6-1.2 1.7-2.9v-1.2l-.7-1.1 1.2-2.7-.3-3.6-.6-8.2-1.2-1.4v1.4l.5.6h-1.1l-.6-.4-1.3-.2-.9.6-1.2-1.6.7-1.7v-1l1.7-.7.8-2.1.2.7 1.5-2.3 1.5-1.7 1.3-3.3 5.4-4.5 1.7-1.3h.8l2.4-3.1 1.4.1 2.9-1.1h2.1l5.3-2.7 2.8-.9 1-1 1.5.5 5.6-3.6.1-3-.8-.8.4-.6-.1-1.3-.9-.7 1.2-.4-.9-1.6 1.8.7.3 1.4.7 1.2-1.4-.8 1.1 1.7-.3 1.2-.6-1.1v2.5l.6-.9.4.9 1.3-1.5-.2-2.5 1.4 3.1 1-.9.4-1 1.1.2 1.2-1.1-.4-1.2.3-1.1h1.2l1-1.2.1-1.3.9.1.3 1.3.5.6-.5 1.9-3.3 3.3h1.2l2-1.9 2-2.1 2.2-1.2.1-1.2 1.6-1 .9.3 3.5-2.3.7 1v1.8l1-2.8-1.2-3.3-1.3-2.7-2.3-2.1-1.8-.4-1.3 1.1 1.2 1 .4-.9h.8l1.5 3.6.3-.9 1.2 2.1-1.1.3-1.6 1.2-.8.9-1.9.1h-1.9l-1-.7-.6-2-.8-1.1-1.8-.1-.2-2.6-2.5-2.6h-1.8l-1.1-.6-.3.8-.9.2-.6-1 .8-.7-.9-1.2 1.3-.3-.4-.8.9-1-.2-.8 3-2.4v-1.1l-.8-1.3-1.1 1.3-1-.4-1.7-3.3.8-4.8 1.4-.3 1-3-.8-2.9 1.6-.9.5-2.8-.6-1.3 3.3-1.9-2.2-2.3.9-2.4 1.4-2.2.5 3.2 1.6-2 1.3.9 1.2-.8v-1.7l3.2-1.3.3-2.9 2.5-.2 2.7-3.7v-.7l-.9-.5-.1-3.3.6-1.1.2 1.6 1-.5-.2-3.2-.9.3-.1 1.2-1.2-1.4.9-1.4.6.1 1.1-.4.5 2.8 2-.3 2.9.7v-1l-1.1-1.2 1.3.1.1-2.3.6.8.3 1.9 2.1 1.5.2-1 .9-.2-.3-.8.8-.6-.1-1.6-1.6-.2-2 .7 1.4-1.6.7-.8 1.3-.2.4 1.3 1.7 1.6.4-2.1 2.3-1.2-.9-1.3.1-1.7 1.1.5h.7l1.7-1.4.4-2.3 2.2.3.1-.7.2-1.6.5 1.4 1.5-1 2.3-4.1-.1-2.2-1.4-2-3-3.2H921l-.8 2.2-2.9-3 .3-.8v-1.5l-1.6-4.5-.8-.2-.7.4h-4.8l-.3-3.6-8.1-26-7.3-3.7-2.9-.1-6.7 6.6-2.7-1-1-3.9H878l-6.9 19.5.7 6.2-1.7 2.4-.4 4.6 1.3 3.7.8.2v1.6l-1.6 4.5-1.5 1.4-1.3 2.2-.4 7.8-2.4-1-1.5.4-.5 1.7-1.3.1-1-1.1-1.9 1.4-.5 6.1-27.3 6.9-20.6 5.2-2.5-.1-2.1 1.7-5.9 6.4-3.7 6.3-.7 2.4-6.2 6.1.1 3.1 2.3 1.4h1.5l.1 1.8-2 1.3 1.2.7 1.4 2.7-.4 3.2-1.1.5-1.9.4-2.4 3.1-2.5 2.6-2.6 1.3h-3l-3.4.7-1.8 1.6-.9.1-3.2-1.6h-4.4l-8.2 1.6-7.6 3.9.2 3.2 1.8 3 1.7.5 1.7 3.3-.8 1.1-2.3 2-.6 2.4-3.9 2.5-.6 1.7-4.3 3.9-4.2 3.4-.9.1-2.7 3-3.3 1.7-9.3 5.1-3.8 3.1-4.9 5.9-5.2.3-3.6 2.1-2.5 1.7-1.5.1-2.2-1.5-2.4.4-1.6 1.5-1.9-.8 2-1.1 3.1-.5.1-1h-1.5l-1.3-.8-1 1.5h-1l-.7-.9-2.1-.6-3-1.3-1.9.4-.9-1.1.5-1.2 3.9-5.9v-4.3l.8-2.1 2.2-.8 2-7.8 1-.5 1 .6-.2.6-1.1.8.3.9.8.4 1.9-1.4.4-9.8-1.6-2.3-1.2-3.7v-2.5l-2.3-4.4v-1.8l-1.2-3.3-2.3-3-2.9-1-4.8 3-2.5 4.6-.2.9-3 3.5-1.5-.2-2.9-2.8-.1-3.4 1.5-1.9 2-.2 1.2-1.7.2-4 .8-.8 1.1-.1.9-1.7-.2-9.6-.3-1.3-1.2-1.2-1.7-1-.1-1.8.7-.6 1.8.8-.3-1.7-1.9-2.7-.7-1.6-1.1-1.1h-2.2l-8.1-2.9-1.4-1.7-3.1-.3-1.2.3-4.4-2.3h-1.4l.5 1-2.7-.1.1.6.6.6-2.5 2.1.1 1.8 1.5 2.3 1.5.2v.6l-1.5.5-2.1-.1-2.8 2.5.1 2.5.4 5.8-2.2 3.4.8-4.5-.8-.6-.9 5.3-1-2.3.5-2.3-.5-1 .6-1.3-.6-1.1 1-1v-1.2l-1.3.6-1.3 3.1-.7.7-1.3 2.4-1.7-.2-.1 1.2h-1.6l.2 1.5.2 2-3 1.2.1 1.3 1 1.7-.1 5.2-1.3 4.4-1.7 2.5 1.2 1.4.8 3.5-1 2.5-.2 2.1 1.7 3.4 2.5 4.9 1.2 1.9 1.6 6.9-.1 8.8-.9 3.9-2 3.2-.9 3.7-2 3-1.2 1-1.7 1.6-5.1 2.3-4.7-1.4-1.6-3.2-1.2-4.1-3.4-4.6-.1-4.6-.3-4 .4-3-1.3-1.5V188l-1.1-.9.5-1.1-.8-1.7.3-.3-1-1.5 1.5-5 1.1-4.1-.4-3.7-.3-1.6.9-3.1-.3-1.9 2.4-1.9-.1-1.3-.6-2 .3-4.2 2.8-7.2.7-.5 1.2-4.5.6-.1.7-2.2-.5-1.2 1-.1v-2l-1.4-.1-1 .9v1.5l-1.8 1.1-.4 2.1-.7.9-.8 3.3-3.5 1.1-1.6 4.2-2 1.1-.5 1.6-.8.7-.6-.7.2-3.1 2.4-3.4-.2-2.3 2.9-.8.3-3 .8-1.8 2.9-4.6 1.6-6 2.3-2-.5-1.6.5-.9 1 1.6-.3 2.2 2.9-2.2.2-2.3 2.1.6.8-1.6.7.6-.7 1.5-1 .5-1 2 1.4 1.8 1.1-.5-.5-.7 1-1.5 1.9-1.7h.8l.2-2.6 2-1.8 7.9-.5 1.9-3.1 3.8-.3 3.8 1.2 4.2 2.7.7-.2-.2-3.5.7-.2 4.5 1.1 1.5-.2 2.9-.7 1.7.4 1.8.1v-1.1l-.7-.9-1.5-.2-1.1-.8.5-1.4-.8-.3-2.6.1-.1-1 1.1-.8.6.8.5-1.8-.7-.7.7-.2-1.4-1.3.3-1.3.1-1.9h-1.3l-1.5 1-1.9.1-.5 1.8-1.9.2-.3-1.2-2.2.1-1 1.2-.7-.1-.2-.8-2.6.4-.1-4.8 1-2-.7-.1-1.8 1.1h-2.2l-3.8 2.7-6.2.3-4.1.8-1.9 1.5-1.4 1.3-2.5 1.7-.3.8-.6-1.7-1.3-.6v.6l.7.7v1.3l-1.5-.6h-.6l-.3 1.2-2-1.9-1.3-.2-1.3 1.5-3.2-.1-.5-1.4-2-1.9-1.3-1.6v-.7l-1.1-1.4-2.6-1.2-3.3-.1-1.1-.9h-1.4l-.7.4-2.2 2.2-.7 1.1-1-.7.2-1 .8-2.1 3.2-5 .8-.2 1.7-1.9.7-1.6 3-.6.8-.6-.1-1-.5-.5-4.5.2-2 .5-2.6 1.2-1.2 1.2-1.7 2.2-1.8 1-3.3 3.4-.4 1.6-7.4 4.6-4 .5-1.8.4-2.3 3-1.8.7-4.4 2.3-1.9-.7-3.3-1.9v1.4l-2.3 1.1-.4-.9 1.4-1.6-.5-1.5 1.2-1.4.8-1.6-2.2-1.6-1 1-.3-.5-1.8 1.7-1.8.9-.4-.8-.7 1.2h-1.2l-.3 1-6.8 2.6h-2.6l-1.2-2.2 4.3-3.1 3.1-3.7 1.6-.8L554 95l6.3-5.8 3.9-2.1 6.3-2.7 7.6-4.5-.6-.4-3.7.7-2.8.1-1-1.6-1.4-.9-9.8 1.2-1-2.8-1.6-.1-1.7.8-3.7 3.1h-4.1l-2.1-1-.3-1.7-3.9-.8-.6-1.6-.7-1.3-1 .9-2.6.1-9.9-5.5h-2.9l-.8-.7-3.1 1.3-.8 1.3-3.3.8-1.3-.2v-1.7l-.7-.9h-5.9l-.4-1.4h-2.6l-1.1.4-2.4-1.7.3-1.4-.6-2.4-.7-1.1-.2-3-1-3.1-2.1-1.6h-2.9l.1 8-30.9-.4-55.3-1.6-44.5-3.4-53.5-5.6-54.3-7.7-65.9-12.5-14.2-3L151 22l-31.7-8Zm737.9 293.2 2.2 4.3.3 1.3 3.4 5.5 1.8 2.1 1.3 1-1.4-2.8-2.2-3.4-2.4-3-2.2-4.3zM87.2 11l.5 1.4.6-1.2zm-1.8.2-.9.1 1.8 1.5.2-.6Zm2.9 1.1-1 1.4.8.4-.4 1.1 1.7-.5-.2-2.2Zm1.5.2.2 2.4.8-.4.9-.2-.7-1.5Zm-3.8.7-1.4.1.3 2.7 1.6 1.3.6-1.9zm3.2 2.2-1.1.2-.7 1.4.4 1.3.5.6 1.3-.3.2-1 1.2-1.8-1-.4-.7 1.6ZM88.1 35l-.2 1.9.9.8.4-2.7Zm.1 4.9L87 41.8l-.1.8.4.2.5-.6 1.1.1zm-5 4.3-.2.8-.5.4.2.9.7-.4-.1-.6.5-.3-.1-.8zm509.9 30.7-2.3.2-2.7 1.9-7.1 5.3.8 1 1.8.3 2.8-2-1.1-.5 2.3-1.6h1l3-1.9-.1-.9zM564.6 101l-.3 1.9 1.2-.5.1-1.4Zm341.2 2.3-.4 1.2-.5.5.9 1.3 1 .5.3-1V104Zm-341.8.2-2.2.5-.2.9h1.7l.6-.4Zm345.6.5-1 .8v1.3l.7-.8.9.8.4-.5 1.1.2-1-.8.4-.8zm-346.5 1.6-1 .3-.2.7.9-.1zm340.7.3-1.6 2.4 1.7 1.7.9.2 1-1v-1.1l-1-.8-.2-1.1zm4.1.7-1 1.1.5.4-.1 1h1.1v-1.8zm-346.4.1-.5.1-1.5 1.6.2.5 1.5-.6v-.6l.9-.3zm109.2 5.9-1.9.1-.1.5 1.1.4-1.6.8-.3 1-.6-.6-.4.8 1.3 1.2 3.8.1.6-.5-.2-2zm-15.8 6.6v.9l.8-.2v-.5zm1.5 1.4-.4.3.9.4 1.1 1.1 1.6-.1-.1-1.1-1.6-.2-.6-.4zm-14.8 2.9-.1 1.1-.3.7.2 2.2.4.3.7.1.5-.9.1-1.6-.3-.6-.1-1.1zm-18.7 9.4-2 .3-.4 1.3 1.3 1.7zm11.3 4.8v1l2.1 1.6-.2-2.4zm-.7 2.8.1 1h1v-.9zm268.9 30 .4 1-1.5 1.5H899l.1.8.8.4h3.4l.9-.6.1-1.3zm-9.1.8-.8.2-1.2 1-.6 2.1-1 .8 1.2.6 1.1-1.3 2.8-.7 1.3-.3-.5-1.9-.6.6-1.1-.2zm-14.2 9.7-.7.7.1 1.2h.9l.5-.6zm-6.2.6-1.3.1-.5 1zm-3.9 2.9-.7.9h-.7l-1.1.8-.2 1-2.2 2.1-.4.9-1.4.9-7.7 1.9.2.9-.9.7-2 .3-1-.6-.2 1.1-1.1-.4.1 1-1.2-.1-1.2.5-.2 1.1h-1l.2 1h-.7l.2 1-1.8.4-1.5 2.3-.2 2.1.7.6 1.3-.3 1.1.3.9-1.3h1.9l2.4-.9 5.1-2.1-.5-.5-1.9.8-2 .9.2-.8 2.6-1.1.8-1 1.2.1 4.1-2.3v.7l-4.2 3 4.5-2.8 1.7-2.2 1.5-.1 4.5-3.1 3.2-3.1 3-2.3 1-1.2-1.7-.1-1 1.2-.2.7-.9.7-.8-1.1-1.7 1-.1.9-.9-.2.5-.9-1.2-.7-.6.9.9.3.2.5-.3.5-1.4 2.6h-1.9l.9-1.8.9-.6.3-1.7 1.4-1.6.9-.8 1.5-.7zm-27.5 19.4-1.6.4v1l-.7 1.6.6.7 2.4-2.3-.1-.9zm-20.2 59.7-1.3.9.8 1.8 1.7.8-.4-1.6zm.8 4v1.8l-.1.6.9-.1v-2.3zm7.4 16.6-1 2.7 1.2-1.3zm7.5 27.4v1l2.5 2.2-.2-1.4-1.4-1.6zm4.2 2.7 1.7 4.2.4 3.1v3.7l-4.6 3.3-2.7 2.5.1 1.4 3.2-3.2 3.1-2.4 1.7-.4-.4-7.6-1-3.2zM51.4 336.8v2.4l2 1.2 4.4-.2 1-1-3.1-.2Zm-5.9.1.9 2.7h3.8l-1.4-2.2zm27 18.5-1.2.4 1.8 4.1 2.6 1 .7-.6-1.3-2.5zm-3.1 10.2.2 3.4 1.8 1.9 1.4-.1zM590.6 470l1.6.1 1.9 1 .8 1.1 2.5.1 1.5.8.2 1.4-.4.6-.9-1.5-1.4 1.2-.9 1.4-2.8.8-1.6.1-3.7-1 .1-1.7 2-2zm-4.5.7 1.4.6v1.1l-1.8 2h-1.2v-2.2zm-115 47-2.6 1-3.6 2.3-.7 1.5-8.2 11.6-2.8 7.9v8.8l3.6 12 .4 4.5.8.1-.6-4.8-3.5-12.3-.2-8.1 4.9-10.5 6.1-8.2 7.2-5.1v-.7zm326.4 34.6-1.7 5.6-.8 1-1 2.6-1.2 1.6-.7 1.7-1.9 2.2v.9l2.7-2.8 2.4-3.5.6-2 2.1-4.9Zm-8.3 15.7-1.1.3-1.4 2 1.1-.2 1.5-1.6zm-3.8 2.9-3 1.4-1 1.3 1.1.1zm-8 1.9-2.4.9-1.5.6-3.7 3.3-1.6.2v.7l2.3.1 3.9-2.5h2.4l2.6-1.2-1.7-.8zm-15.5 5.7-1 1.1 1.7-.1z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    style: {
      display: "inline",
      stroke: "#ccc",
      strokeWidth: 1,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "al-fl",
    d: "m687.6 447.4-48.8 5.1-.5 2.9 2.5 2.8 1.7.7.9 1.2-.4 7.3-1.1.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "al-ga",
    d: "m666.6 361.1 12.9 45.8 2.9 6.1 1.8 1.9v3.2l1.7 1 .2 1.1-2.2 3.8-.3 3.7-.5 2.6 2.4 5.7-.6 6.3.5 1.4 1.5 1.5.7 2.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "al-ms",
    d: "m620.9 365.1 1.3 2-1.3 67 4.4 33.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "al-tn",
    d: "m620.9 365.1 45.7-4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar-la",
    d: "m516.7 414.2 52.3-1.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar-mo",
    d: "m591.7 344.9-11.2.8 2.8-5.1 1.7-1.5v-2.2l-1.6-2.5-39.8 2-39.1.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar-ms",
    d: "m569 412.9 1.2-1.5.5-3-1.5-2.3-.5-2.2.9-.7v-.8l-1.7-1.1-.1-.7 1.6-.9-1.2-1.1 1.7-7.1 3.4-1.6v-.8l-1.1-1.4 2.9-5.4h1.9l1.5-1.2-.3-5.2 3.1-4.5 1.8-.6-.5-3.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar-ok",
    d: "m507.9 400.5.7-39-4.1-24.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar-tn",
    d: "m582.6 367.7 1.6-.7.9-2.2 1.2.5.7-1-.8-.7.3-1.5-1.1-.9.6-1-.1-1.5-1.1-.1.8-.8 1.3.8.3-1.4-.4-1.1.1-.7 2 .6-.4-1.5 1.6-1.3-.5-.9-1.1.1-.6-.9.9-.9 1.6-.2.5-.8 1.4-.2-.1-.8-.9-.9v-.5h1.5l.4-.7-1.4-1-.1-.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar-tx",
    d: "m507.9 400.5 2.6 2.3 2.8-1.3 3.2.8.2 11.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "az-ca",
    d: "m149 338.1-.9 2.1 1.3 3.4 1.4 1.8 1.2 5.8 2.3 2.5.4 1.9-1.3 1.3-4.8 1.7-2.4 3.6-1.6 7-2.4 3.2-1.6.3-1.1 6.9 1.1 1.6 1.8.2 1 1.6-.8 2.4-3 2.2-2.2-.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "az-nm",
    d: "m253.8 311-17.4 124.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "az-nv",
    d: "m167.6 296.8-3.4 17.5-2.4 2.9h-2l-1.2-2.7-3.7-1.4-3.5.6-1 13.6.5 4.9-.5 2.9-1.4 3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "az-ut",
    d: "m167.6 296.8 46.2 8.2 40 6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ca-nv",
    d: "m93.9 166.5-16.4 63.1 1.1 3.5 70.4 105",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ca-or",
    d: "m27.8 147.9 66.1 18.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "co-ks",
    d: "m379.4 256.3-4.8 67",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "co-ne",
    d: "m347.7 231.8 33.1 2.4-1.4 22.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "co-nm",
    d: "m253.8 311 52.6 6.5 51.7 4.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "co-ok",
    d: "m358.1 322.3 16.5 1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "co-ut",
    d: "M265.3 222.7 253.8 311",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "co-wy",
    d: "m265.3 222.7 44.9 5.7 37.5 3.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct-ma",
    d: "m843.8 171.3 10.5-2.4.5.7.9-.3v-.7l14.9-3.4.1.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct-ny",
    d: "m846.6 194.7-1.7-2.2 3.5-3.4-1.8-1.5-2.8-16.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct-ri",
    d: "m870.7 165.5 3.2 12.3-.4 1.1.4 1.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dc-md",
    d: "m801.8 254.6 1.7-2.6-2.6-1.8-1 1.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "dc-va",
    d: "m799.9 251.9.5.4.4.1.6.5.3.7-.1.5.2.5",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "de-md",
    d: "m817.9 230.1 7.6 27.1 10.9-2.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "de-nj",
    d: "m823.8 227.2-1 2.2-.3 2.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "de-pa",
    d: "m817.9 230.1 1.2-2.1 1.5-1.1 1.6-.3 1.6.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fl-ga",
    d: "m687.6 447.4 3.3 6 50.1-3.3.6 3.2 1 1.1 2.1-.6.5-4.3-1.4-2.1v-2.5l2.2-1.4 1.7.9 4 .7 3.6-.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ga-nc",
    d: "m689.5 358.2 21.4-3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ga-sc",
    d: "m710.9 355.2-.1 1.9-1.9 1-1.4 3.2.2 1.3 6.1 3.8 2.6-.3 3.1 4 .4 1.7 4.2 5.1 2.6 1.7 1.4.2 2.2 1.6 1.1 2.2 2 1.6 1.8.5 2.7 2.7.1 1.4 2.6 2.8 5 2.3 3.6 6.7.3 2.7 3.9 2.1 2.5 4.8.8 3.1 4.2.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ga-tn",
    d: "m666.6 361.1 22.9-2.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ia-il",
    d: "m556.8 249.7.7-.7.1-2.3-.7-.9 1-1.5 1.8-.6.9-.3 1-1.2v-2.4l1.7-2.4.5-.5.1-3.5-.9-1.4-1-.3-1.1-1.6 1-4 3-.8h2.4l4.2-1.8 1.7-2.2.1-2.4 1.1-1.3 1.3-3.2-.1-2.6-2.8-3.5h-1.2l-.9-1.1.2-1.6-1.7-1.7-2.5-1.3.5-.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ia-mn",
    d: "M473.6 182h28.2l36.3-.9 18.6-.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ia-mo",
    d: "m484.5 246.8 25.9.1 27.2-1.2 14.3-.8 1.7 1.3.6 1.6 1.1 1.1 1.5.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ia-ne",
    d: "m484.5 246.8-1.8-4.4.7-2.2-.8-3.3.2-2.9-1.3-.7-.4-6.1-2.8-5-.2-3.7-2.2-4.3-1.3-3.7v-1.4l-.6-1.7v-2.3l-.5-.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ia-sd",
    d: "m473.5 204.2-.7-1.7-.3-1.3-1.3-1.2 1-4.3 1.7-5.1-.7-2-1.3-.4-.4-1.6 1-.5.1-1.1-1.3-1.5.1-1.6 2.2.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ia-wi",
    d: "m567.2 202-1.3-2.8-3.3-.7-2.7-1.5-2-5.5.1-2.5 1.6-3.3-.6-1.1-2.1-1.6-.2-2.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "id-mt",
    d: "m188.8 30.5-4.8 22 3.7 7.4-1.6 4.8 3.6 4.8 1.9.7 3.9 8.3v2.1l2.3 3h.9l1.4 2.1h3.2v1.6l-7.1 17-.5 4.1 1.4.5 1.6 2.6 2.8-1.4 3.6-2.4 1.9 1.9.5 2.5-.5 3.2 2.5 9.7 2.6 3.5 2.3 1.4.4 3v4.1l2.3 2.3 1.6-2.3 6.9 1.6 2.1-1.2 9 1.7 2.8-3.3 1.8-.6 1.2 1.8 1.6 4.1.9.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "id-nv",
    d: "m140.9 177.7 24.4 5.4 23.3 4.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "id-or",
    d: "m140.9 177.7 8.5-37.3 2.9-5.8.4-2.1.8-.9-.9-2-2.9-1.2.2-4.2 4-5.8 2.5-.8 1.6-2.3-.1-1.6 1.8-1.6 3.2-5.5 4.2-4.8-.5-3.2-3.5-3.1-1.6-3.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "id-ut",
    d: "m236.5 196-47.9-8.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "id-wa",
    d: "m174.6 27.5-12.7 56.1.7 4-1.1 4.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "id-wy",
    d: "m245 141.2-8.5 54.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "il-in",
    d: "m619.4 215.7 4.1 50.2-1 5.2v2l2.4 3.5v.7l-.3.9.9 1.9-.3 2.4-1.6 1.8-1.3 4.2-3.8 5.3-.1 7h-1l.9 1.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "il-ky",
    d: "m599.9 322.5-.3-1.8 4-3.7 6.9 3 1.5-.3.4-2.4-1.7-1.8.4-3.3 1-.5 1.2.6.6-1.2 3.7-.6.1-.9-1.5-2.2-.1-1.1 2.2-2.7v-.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "il-mo",
    d: "M599.9 322.5h-2.8l-1.4-1.5-1.8-3.8v-1.9l.8-.6.1-1.3-1.7-1.9-.9-2.5-2.7-4.1-4.8-1.3-7.4-7.1-.4-2.4 2.8-7.6-.4-1.9 1.2-1.1v-1.3l-2.8-1.5-3-.7-3.4 1.2-1.3-2.3.6-1.9-.7-2.4-8.6-8.4-2.2-1.5-2.5-5.9-1.2-5.4 1.4-3.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "il-wi",
    d: "m567.2 202 45.9-2.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "in-ky",
    d: "m618.3 302.7 1.1.8.6-1-.7-1.7 4.6-.5.2 1.2 1.1.2.4-.9-.6-1.3.3-.8 1.3.8 1.7-.4 1.7.6 3.4 2.1 1.8-2.8 3.5-2.2 3 3.3 1.6-2.1.3-2.7 3.8-2.3.2 1.3 1.9 1.2 3-.2 1.2-.7.1-3.4 2.5-3.7 4.6-4.4-.1-1.7 1.2-3.8 2.2 1 6.7-4.5-.4-1.7-1.5-2.1 1-1.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "in-mi",
    d: "m630.9 213.2 32.4-3.4.1 1.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "in-oh",
    d: "m670 268.4-6.6-57.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ks-mo",
    d: "m504.3 326.3-.5-48.1-3.2-.7-2.6-4.7-2.5-2.5.5-2.3 2.7-2.6.1-1.2-1.5-2.1-.9 1-2-.6-2.9-3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ks-ne",
    d: "m379.4 256.3 36 2 43.7 1.2h32.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ks-ok",
    d: "m374.6 323.3 67.7 2.9 62 .1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ky-mo",
    d: "m596.7 333.5 1-2.7 1.4.9.7-.4 1.2-4.1-1-1 1-2 .2-.9-1.3-.8m-5.8 11.3-.7-.7.2-1h1.1l.7.7-.3 1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ky-oh",
    d: "m670 268.4 1.3.5 2.2.1 1.9-.8 2.9 1.2 2.2 3.4v1l4.1.7 2.3-.2 1.9 2.1 2.2.2v-1l1.9-.8 3 .8 1.2.8 1.3-.7h.9l.6-1.7 3.4-1.8.5.8.8 2.9 3.5 1.4 1.2 2.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ky-tn",
    d: "M596.7 333.5 620 332l.6-.9-1.2-3.2h3.7l.7.6 22.6-2 2.6-.8 17.4-1 5.2-.8 20.5-1.4 5.6-1.4m-103.6 12.7h1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ky-va",
    d: "m697.7 321.1 6.9-4.2 1-.4.5-1.9 1.8-.5 1.4-1.4.1-1.7 2.1-1.3.4-2.2 3-3 2.9-1 4.9-6.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ky-wv",
    d: "m709.3 279.4-.1 1.1.6 1-.6 3.6 1.9 1.6.8 1.1 1 .6-.1.9 4.4 5.6h1.4l1.5 1.8 1.2.3 1.4-.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "la-ms",
    d: "m569 412.9-.6 1.4 1.6 7.1 1.2 1-.5 1.7 2.4 2.5v3.3h-2l1.8 2.5-6 8.4-2.4 4.8-1.7 11.9 36-2-.1 1.4-1 1.4-.9 4.6 4.8 6.8-.3 1.3 1.2 1.8.6.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "la-tx",
    d: "m516.7 414.2.5 19.9.7 3.4 2.6 2.8.7 5.4 3.8 4.6.8 4.3h1l-.1 7.3-3.3 6.4 1.3 2.3-1.3 1.5.7 3-.1 4.3-2.2 3.5-.1.8-1.7 1.2 1 1.8 1.2 1.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ma-nh",
    d: "m856 152.6 18.4-3.8 1-1.5.3-1.7 1.9-.6.5-1.1 1.7-1.1 1.3.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ma-ny",
    d: "m843.8 171.3-.7-1 .5-15",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ma-ri",
    d: "m870.7 165.5 6.5-2 .7 2.6h.8l.6 2.2 2.6 1.3 1.3 1.1 1.4 3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ma-vt",
    d: "m843.6 155.3 12.4-2.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "md-pa",
    d: "m757.4 241.9 60.5-11.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "md-va",
    d: "m822.9 269.3-.8.1m13.2-4.3-.6.3m-1.3.2-4.6 1.6-.7.8m-28.2-16.1-.6-.6h-1l-.6-.1-.4-.4.1-.5-1.7-.6-.8.3-1.2-.1-.7-.7-.5-.2-.2-.7.6-.8v-.9l-1.2-.2-1-.9-.9.1-1.6-.3m11.6 13.5.3-.4-.7-1 1-.1 1-.9.4-1.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "md-wv",
    d: "m757.4 241.9 1.7 11.4 1.8-1.6.9-1.6 3.1-3.9 2.2.3 2.6-3.8 1.9 1 3.3-.4 1.7-2.9h1.3l.9-1.4 1.4-.3 2.2 1.6 2.6-.4-.2 1 .8 1.2h.7l.2.7 1 .5-.2 1.6.9.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "me-nh",
    d: "m881.9 138.3-2.3-1.4-.8-2.2-3.2-2-.6-4-11.9-36.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mi-oh",
    d: "m663.4 211.2 21.4-3.5",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mi-wi",
    d: "m565.6 112.3 1.9.7 3 3.8 17 3.8 1.4 1 4 .8.7.5 2.8-.2 4.9.8 1.4 1.5-1 1 .8.8 3.8.7 1.2 1.2.1 4.4-1.3 2.8 2 .1 1-.8.9.8-1.1 3.1 1 1.6 1.2.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mn-nd",
    d: "m462.3 61.3 2.4 7.3-1.1 2.8.8 1.4-.3 5.1-.5 1.1 2.7 9.1 1.3 2.5.7 14 1 2.7-.4 5.8 2.9 7.4.3 5.8-.1 2.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mn-sd",
    d: "m473.6 182 .2-39.5-1.5-1.9-2.6-.6-.4-1.8-1.7-2.5.3-1.2 3.1-1.9.9-2 .1-2.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mn-wi",
    d: "m556.7 180.4-1.1-4.5-.2-3-2.2-3-2.8-.7-5.2-3.6-.6-3.3-6.3-3.1-.2-1.3h-3.3l-2.2-2.6-2-1.3.7-5.1-.9-1.6.5-5.4 1-1.8-.3-2.7-1.2-1.3-1.8-.3v-1.7l2.8-5.8 5.9-3.9-.4-13 .9.4.6-.5.1-1.1.9-.6 1.4 1.2.7-.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mo-ne",
    d: "m491.5 259.5-3.9-6.3-2.1-3.7.3-1.4-1.3-1.3",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mo-ok",
    d: "m504.3 326.3.2 10.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mo-tn",
    d: "m591.7 344.9 1-2 1.2-.5v-.7l-1.2-1.1-.6-1 1.7.2.8-.7-1.4-1.5 1.4-.5.1-1-.6-1v-1.3m1 0 .8.7.8-1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ms-tn",
    d: "m582.6 367.7 38.3-2.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mt-nd",
    d: "m362.5 56.3-5.2 66.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mt-sd",
    d: "m357.3 123-2 20.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "mt-wy",
    d: "m355.3 143.7-51-5.3-57.3-7.9-2 10.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nc-sc",
    d: "m710.9 355.2 4.4-1.9 1.3-.1 7.3-4.3 23.2-2.2.4.5-.2 1.4.7.3 1.2-1.5 3.3 3 .1 2.6 19.7-2.8 24.5 17.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nc-tn",
    d: "M731.1 317v5.2l-1.5-.1-1.4 1.2-2.4 5.2-2.6-1.1-3.5 2.5-.7 2.1-1.5 1.2-.8-.8-.1-1.5-.8-.2-4 3.3-.6 3.4-4.7 2.4-.5 1.2-3.2 2.6-3.6.5-4.6 3-.8 4.1-1.3.9-1.5-.1-1.4 1.3-.1 4.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nc-va",
    d: "m731.1 317 29.4-3.5 39.4-7.3 29.1-6.1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nd-sd",
    d: "m357.3 123 39.2 2.9 46 2.1 29.5.4",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ne-sd",
    d: "m351.4 187.6 51.1 3.5 38 1.6 3.4 3.2 1.7.2 2.1 2 1.8-.1 1.8-2 1.5.6 1-.7.7.5.9-.4.7.4.9-.4 1 .5 1.4-.6 2 .6.6 1.1 6.1 2.2 1.2 1.3.9 2.6 1.8.7 1.5-.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ne-wy",
    d: "m347.7 231.8 3.7-44.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nh-vt",
    d: "m857.9 100.1 1.2 2.3-1.1 3.5 2.1 2.8-.4 1.7.1 1.3-1.1 2.1-1.4.4-.6 1.3-2.1 1-.7 1.5 1.4 3.4-.5 2.5.5 1.5-1 1.9.4 1.9-1.3 1.9.2 2.2-.7 1.1.7 4.5.7 1.5-.5 2.6.9 1.8-.2 2.5-.5 1.3-.1 1.4 2.1 2.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nj-ny",
    d: "m827.9 190.5 14.6 4.9-.4 5.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nj-pa",
    d: "m823.8 227.2 1.4-1.7 1.6-.6 1.8-3 1.6-2.3 3.3-2.6-4.2-3.2-2.1-1.1-1-2.8-2.7-.9-.5-3.6 1-1 .7-2-1.5-1.8 3-5.4-.1-2.2 1.8-2.5",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nm-ok",
    d: "m358.1 322.3-.6 10.6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nm-tx",
    d: "m284.3 431.2-2-2.2.3-3 34.4 3.6 31.8 2.6 7.9-99.3h.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nv-or",
    d: "m93.9 166.5 47 11.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "nv-ut",
    d: "m188.6 187.8-21 109",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ny-pa",
    d: "m827.9 190.5-1.6-1.1-1.9.3-3-2.2-3-5.8h-2l-.4-1.5-1.7-1.1-70.5 13.9-.8-6",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ny-vt",
    d: "m843.6 155.3-1.1-1 .5-2-3-14.2-1.9-1.5-.9 1.6-.9-2.2.8-1.8-3.1-6.7.3-3.8.4-1-.6-2 .4-2.2-2.2-2.3-.5-3.2.4-1.5-1.4-.9.6-1.9-.8-1.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "oh-pa",
    d: "m736.8 225.1-4.9-29.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "oh-wv",
    d: "m709.3 279.4 3.2-1.4h1.5l.4-3.5 1.5-.8-1.3-3.6 1.1-1.3.3-2.2 1-2.3 1.6.5.6 2.1 1-.5.7-.8 1-.2v-1.9l-1.4-1.1 1-.5-.1-2.1 1.3-2.2h1.3l.3-1.2 1.5-1.8 1.3 1.2 1.8-1.7h.6l1.8-2 2-3.3 1.1-.5.4-2.2-.5-1.1 1-3.6.1-5.4 1.1-3.4-.6-2 .1-2.2-1.4-2.1 2.2-1.2",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ok-tx",
    d: "m357.5 332.9 52.6 3.2-1.4 42.7 2.7 1.3 2.5 3 1.5.3 1.1-1 1.2.4 1.4 1 1.1-1.5 2.3 1.7.5 2.9 1.2.7 2.3-.1 3.5 1.9 2-.1 1.4-.4 2.3 2.2 2-2.3 3.5 1.1 1.9 3 2.3-.1-.7 2.1 2.3 1.1 3-2.6 2.6 1.7 1.3-.5.1 1.5 1.7 1.2 2.3-2.5 1.2.7-.3 2 1 1.8 1.2-.8 2.5-4.2 1.8 2 2 .5 2.1-.7 2 1.8 1.2-.1 1.3 1.2 3.6-.9.6-1.7 3.7-.3 1.6.7 5-2.5.6 1.5 5.1-.3.5-1.6 2.2.9 4.6 3.8 6.4 1.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "or-wa",
    d: "m161.5 91.9-30.3-7.3-2.8 1-5.4-.9-1.8-.9-1.5 1.2-3.3-.4-4.5.5-.9.7-4.2-.4-.8-1.6-1.2-.2-4.4 1.3-1.6-1.1-2.2.8-.2-1.8-2.3-1.2-1.5-.2-1-1.1-3 .3-1.2-.8h-1.2l-1.2.9-5.5.7-6.6-4.2 1.1-5.6-.4-4.1-3.2-3.7-3.7.1-.4-1.1.4-1.2-.7-.8-1 .1",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "pa-wv",
    d: "m736.8 225.1 3.2 19.7 17.4-2.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "sd-wy",
    d: "m351.4 187.6 3.9-43.9",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "tn-va",
    d: "m697.7 321.1 28.9-3.3.2-1 4.6-.5-.3.7",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ut-wy",
    d: "m236.5 196-3.3 21.9 32.1 4.8",
    style: {
      stroke: "#ccc",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "va-wv",
    d: "m722.7 296.9.7.6-.8 1.2 1.5.7.1 1.5 4.4 2.3 2.3-.1 1.9-1.8.8-1.7 3 1.8 5.5-2.4.5-.9-.8-.5.6-1.4 1.5 1 4.3-3.1.7 1.1 2.3-2-.1-1.4 1.5-1.9-1.5-1.2 1-3.3 3.7-6.3-.4-1.9 2.1-2.2-.4-1.5 1.4-1.7.1-4.7 2.3.7 1.3 1.9 2.8.5 1.3-1.6 2.3-8.5 2.4 1.1 1-2.5.9-.8 1.4-1.8.9-.8.5-2.1 1.2-.8-.1-2.9.8-2.3-.9-1.6.2-.9 10 5.2.5-2.3.4-1.6.4-.7",
    style: {
      display: "inline",
      stroke: "#ccc",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 2.5,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.9,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m555.3 248.9-1.1-1.1-.6-1.6-1.7-1.3-14.3.8-27.2 1.2-25.9-.1 1.3 1.3-.3 1.4 2.1 3.7 3.9 6.3 2.9 3 2 .6.9-1 1.5 2.1-.1 1.2-2.7 2.6-.5 2.3 2.5 2.5 2.6 4.7 3.2.7.5 48.1.2 10.8 39.1-.7 39.8-2 1.6 2.5v2.2l-1.7 1.5-2.8 5.1 11.2-.8 1-2 1.2-.5v-.7l-1.2-1.1-.6-1 1.7.2.8-.7-1.4-1.5 1.4-.5.1-1-.6-1v-1.3l-.7-.7.2-1h1.1l.7.7-.3 1 .8.7.8-1 1-2.7 1.4.9.7-.4 1.2-4.1-1-1 1-2 .2-.9-1.3-.8h-2.8l-1.4-1.5-1.8-3.8v-1.9l.8-.6.1-1.3-1.7-1.9-.9-2.5-2.7-4.1-4.8-1.3-7.4-7.1-.4-2.4 2.8-7.6-.4-1.9 1.2-1.1v-1.3l-2.8-1.5-3-.7-3.4 1.2-1.3-2.3.6-1.9-.7-2.4-8.6-8.4-2.2-1.5-2.5-5.9-1.2-5.4 1.4-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.9,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m555.3 248.9-1.1-1.1-.6-1.6-1.7-1.3-14.3.8-27.2 1.2-25.9-.1 1.3 1.3-.3 1.4 2.1 3.7 3.9 6.3 2.9 3 2 .6.9-1 1.5 2.1-.1 1.2-2.7 2.6-.5 2.3 2.5 2.5 2.6 4.7 3.2.7.5 48.1.2 10.8 39.1-.7 39.8-2 1.6 2.5v2.2l-1.7 1.5-2.8 5.1 11.2-.8 1-2 1.2-.5v-.7l-1.2-1.1-.6-1 1.7.2.8-.7-1.4-1.5 1.4-.5.1-1-.6-1v-1.3l-.7-.7.2-1h1.1l.7.7-.3 1 .8.7.8-1 1-2.7 1.4.9.7-.4 1.2-4.1-1-1 1-2 .2-.9-1.3-.8h-2.8l-1.4-1.5-1.8-3.8v-1.9l.8-.6.1-1.3-1.7-1.9-.9-2.5-2.7-4.1-4.8-1.3-7.4-7.1-.4-2.4 2.8-7.6-.4-1.9 1.2-1.1v-1.3l-2.8-1.5-3-.7-3.4 1.2-1.3-2.3.6-1.9-.7-2.4-8.6-8.4-2.2-1.5-2.5-5.9-1.2-5.4 1.4-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 14,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M613.26 209.865c0 15.784-.004 30.465-.98 39.246-.977 8.781-2.911 14.436-6.622 18.146-3.71 3.71-9.365 5.644-18.146 6.62-8.781.975-20.605.98-36.387.98h-45.191v2h45.191c15.782 0 27.632.005 36.607-.992 8.975-.998 15.158-3.012 19.34-7.194 4.182-4.181 6.196-10.364 7.194-19.34.997-8.975.994-23.682.994-39.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 14,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M843.572 197.246c-29.797 0-44.754-.162-52.75 5.027-3.998 2.595-6.043 6.594-7.025 12.202-.982 5.607-.999 12.914-1.027 22.62-.03 9.711-.058 16.975-.94 22.303-.881 5.33-2.526 8.63-5.84 10.891-6.627 4.522-20.833 4.711-49.365 4.711h-220.66v2h220.66c28.532 0 42.842.16 50.492-5.059 3.825-2.61 5.758-6.608 6.686-12.214.927-5.607.938-12.915.967-22.625.028-9.707.067-16.965.998-22.282.93-5.316 2.653-8.604 6.142-10.869 6.979-4.53 21.866-4.705 51.662-4.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 14,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M505.945 274.856v2h200.881c9.993 0 17.477.005 23.004.621 5.527.616 9.013 1.828 11.28 4.094 2.266 2.266 3.479 5.752 4.095 11.28.616 5.526.621 16.154.621 26.149v95.893c0 55.292-.174 82.163 5.729 99.761 2.951 8.8 7.476 15.044 14.197 20.725 6.72 5.68 15.613 10.833 27.457 17.672l1-1.733c-11.842-6.837-20.655-11.964-27.166-17.466-6.51-5.503-10.744-11.344-13.592-19.834-5.695-16.98-5.625-43.831-5.625-99.125V319c0-9.995.003-20.649-.635-26.37-.638-5.72-1.93-9.737-4.668-12.473-2.737-2.737-6.751-4.029-12.472-4.666-5.721-.638-13.232-.635-23.225-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 14,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M505.947 274.975c-3.632 0-6.401-.028-8.668.623-2.266.65-3.974 2.153-4.957 4.71-1.966 5.116-1.86 17.48-1.86 36.288v169.45h2v-169.45c0-18.808.083-31.291 1.727-35.57.823-2.14 1.83-2.985 3.641-3.506 1.812-.52 4.485-.545 8.117-.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 14,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M189.441 275c-9.991 0-17.499-.001-23.205.537-5.706.539-9.677 1.611-12.43 3.942-2.752 2.33-4.083 5.811-4.726 10.687-.643 4.876-.639 11.242-.639 19.705 0 8.465-.003 14.798-.607 19.447-.605 4.65-1.767 7.518-4.012 9.422-2.244 1.905-5.772 2.952-11.318 3.475-5.546.522-13.044.527-23.063.527h-30v2h30c10.019 0 17.54.003 23.25-.535 5.711-.538 9.678-1.61 12.424-3.941 2.747-2.331 4.07-5.814 4.703-10.69.634-4.876.623-11.24.623-19.705 0-8.463.008-14.795.622-19.443.612-4.649 1.785-7.518 4.037-9.424 2.251-1.906 5.783-2.954 11.324-3.477 5.54-.523 13.026-.527 23.017-.527h316.592v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 14,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M94.326 34.651v2h40c10.019 0 17.464.032 22.84 1.82 5.376 1.787 8.806 5.172 11.238 12.465 4.864 14.586 4.922 44.58 4.922 104.435v82.486c0 9.5-.007 16.638.63 22.084.635 5.445 1.934 9.286 4.675 11.89 2.74 2.605 6.74 3.823 12.459 4.426 5.718.604 13.233.6 23.236.6h291.807v-2H214.326c-10.003 0-17.492-.004-23.025-.588-5.534-.584-9.034-1.741-11.291-3.887-2.258-2.145-3.457-5.432-4.069-10.673-.612-5.242-.615-12.352-.615-21.852v-82.485c0-59.855.094-89.722-5.023-105.07-2.559-7.672-6.625-11.774-12.506-13.73-5.881-1.955-13.452-1.92-23.47-1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#5e34b2",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M613.26 209.865c0 15.784-.004 30.465-.98 39.246-.977 8.781-2.911 14.436-6.622 18.146-3.71 3.71-9.365 5.644-18.146 6.62-8.781.975-20.605.98-36.387.98h-45.191v2h45.191c15.782 0 27.632.005 36.607-.992 8.975-.998 15.158-3.012 19.34-7.194 4.182-4.181 6.196-10.364 7.194-19.34.997-8.975.994-23.682.994-39.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#5e34b2",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M843.572 197.246c-29.797 0-44.754-.162-52.75 5.027-3.998 2.595-6.043 6.594-7.025 12.202-.982 5.607-.999 12.914-1.027 22.62-.03 9.711-.058 16.975-.94 22.303-.881 5.33-2.526 8.63-5.84 10.891-6.627 4.522-20.833 4.711-49.365 4.711h-220.66v2h220.66c28.532 0 42.842.16 50.492-5.059 3.825-2.61 5.758-6.608 6.686-12.214.927-5.607.938-12.915.967-22.625.028-9.707.067-16.965.998-22.282.93-5.316 2.653-8.604 6.142-10.869 6.979-4.53 21.866-4.705 51.662-4.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#5e34b2",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M505.945 274.856v2h200.881c9.993 0 17.477.005 23.004.621 5.527.616 9.013 1.828 11.28 4.094 2.266 2.266 3.479 5.752 4.095 11.28.616 5.526.621 16.154.621 26.149v95.893c0 55.292-.174 82.163 5.729 99.761 2.951 8.8 7.476 15.044 14.197 20.725 6.72 5.68 15.613 10.833 27.457 17.672l1-1.733c-11.842-6.837-20.655-11.964-27.166-17.466-6.51-5.503-10.744-11.344-13.592-19.834-5.695-16.98-5.625-43.831-5.625-99.125V319c0-9.995.003-20.649-.635-26.37-.638-5.72-1.93-9.737-4.668-12.473-2.737-2.737-6.751-4.029-12.472-4.666-5.721-.638-13.232-.635-23.225-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#5e34b2",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M505.947 274.975c-3.632 0-6.401-.028-8.668.623-2.266.65-3.974 2.153-4.957 4.71-1.966 5.116-1.86 17.48-1.86 36.288v169.45h2v-169.45c0-18.808.083-31.291 1.727-35.57.823-2.14 1.83-2.985 3.641-3.506 1.812-.52 4.485-.545 8.117-.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#c)",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M189.441 275c-9.991 0-17.499-.001-23.205.537-5.706.539-9.677 1.611-12.43 3.942-2.752 2.33-4.083 5.811-4.726 10.687-.643 4.876-.639 11.242-.639 19.705 0 8.465-.003 14.798-.607 19.447-.605 4.65-1.767 7.518-4.012 9.422-2.244 1.905-5.772 2.952-11.318 3.475-5.546.522-13.044.527-23.063.527h-30v2h30c10.019 0 17.54.003 23.25-.535 5.711-.538 9.678-1.61 12.424-3.941 2.747-2.331 4.07-5.814 4.703-10.69.634-4.876.623-11.24.623-19.705 0-8.463.008-14.795.622-19.443.612-4.649 1.785-7.518 4.037-9.424 2.251-1.906 5.783-2.954 11.324-3.477 5.54-.523 13.026-.527 23.017-.527h316.592v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#5e34b2",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M94.326 34.651v2h40c10.019 0 17.464.032 22.84 1.82 5.376 1.787 8.806 5.172 11.238 12.465 4.864 14.586 4.922 44.58 4.922 104.435v82.486c0 9.5-.007 16.638.63 22.084.635 5.445 1.934 9.286 4.675 11.89 2.74 2.605 6.74 3.823 12.459 4.426 5.718.604 13.233.6 23.236.6h291.807v-2H214.326c-10.003 0-17.492-.004-23.025-.588-5.534-.584-9.034-1.741-11.291-3.887-2.258-2.145-3.457-5.432-4.069-10.673-.612-5.242-.615-12.352-.615-21.852v-82.485c0-59.855.094-89.722-5.023-105.07-2.559-7.672-6.625-11.774-12.506-13.73-5.881-1.955-13.452-1.92-23.47-1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#b49be4",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "16,2,8,2,18,2,4,2,14,2,2,2,6,2",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M613.26 209.865c0 15.784-.004 30.465-.98 39.246-.977 8.781-2.911 14.436-6.622 18.146-3.71 3.71-9.365 5.644-18.146 6.62l.22 1.988c8.975-.998 15.158-3.012 19.34-7.194 4.182-4.181 6.196-10.364 7.194-19.34.997-8.975.994-23.682.994-39.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#b49be4",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "16,2,8,2,18,2,4,2,14,2,2,2,6,2",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M843.572 197.246c-29.797 0-44.754-.162-52.75 5.027-3.998 2.595-6.043 6.594-7.025 12.202-.982 5.607-.999 12.914-1.027 22.62-.03 9.711-.058 16.975-.94 22.303-.881 5.33-2.526 8.63-5.84 10.891-6.627 4.522-20.833 4.711-49.365 4.711h-220.66v2h220.66c28.532 0 42.842.16 50.492-5.059 3.825-2.61 5.758-6.608 6.686-12.214.927-5.607.938-12.915.967-22.625.028-9.707.067-16.965.998-22.282.93-5.316 2.653-8.604 6.142-10.869 6.979-4.53 21.866-4.705 51.662-4.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      stroke: "#b49be4",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "16,2,8,2,18,2,4,2,14,2,2,2,6,2",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M729.83 277.477c5.527.616 9.013 1.828 11.28 4.094 2.266 2.266 3.479 5.752 4.095 11.28.616 5.526.621 16.154.621 26.149v95.893c0 55.292-.174 82.163 5.729 99.761 2.951 8.8 7.476 15.044 14.197 20.725 6.72 5.68 15.613 10.833 27.457 17.672l1-1.733c-11.842-6.837-20.655-11.964-27.166-17.466-6.51-5.503-10.744-11.344-13.592-19.834-5.695-16.98-5.625-43.831-5.625-99.125V319c0-9.995.003-20.649-.635-26.37-.638-5.72-1.93-9.737-4.668-12.473-2.737-2.737-6.751-4.029-12.472-4.666zM497.279 275.598c-2.266.65-3.974 2.153-4.957 4.71-1.966 5.116-1.86 17.48-1.86 36.288v169.45h2v-169.45c0-18.808.083-31.291 1.727-35.57.823-2.14 1.83-2.985 3.641-3.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#d)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeDasharray: "16,2,8,2,18,2,4,2,14,2,2,2,6,2",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M189.441 275c-9.991 0-17.499-.001-23.205.537-5.706.539-9.677 1.611-12.43 3.942-2.752 2.33-4.083 5.811-4.726 10.687-.643 4.876-.639 11.242-.639 19.705 0 8.465-.003 14.798-.607 19.447-.605 4.65-1.767 7.518-4.012 9.422-2.244 1.905-5.772 2.952-11.318 3.475-5.546.522-13.044.527-23.063.527h-30v2h30c10.019 0 17.54.003 23.25-.535 5.711-.538 9.678-1.61 12.424-3.941 2.747-2.331 4.07-5.814 4.703-10.69.634-4.876.623-11.24.623-19.705 0-8.463.008-14.795.622-19.443.612-4.649 1.785-7.518 4.037-9.424 2.251-1.906 5.783-2.954 11.324-3.477 5.54-.523 13.026-.527 23.017-.527h316.592v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#b49be4",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "16,2,8,2,18,2,4,2,14,2,2,2,6,2",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "M94.326 34.651v2h40c10.019 0 17.464.032 22.84 1.82 5.376 1.787 8.806 5.172 11.238 12.465 4.864 14.586 4.922 44.58 4.922 104.435v82.486c0 9.5-.007 16.638.63 22.084.635 5.445 1.934 9.286 4.675 11.89 2.74 2.605 6.74 3.823 12.459 4.426l.211-1.988c-5.534-.584-9.034-1.741-11.291-3.887-2.258-2.145-3.457-5.432-4.069-10.673-.612-5.242-.615-12.352-.615-21.852v-82.485c0-59.855.094-89.722-5.023-105.07-2.559-7.672-6.625-11.774-12.506-13.73-5.881-1.955-13.452-1.92-23.47-1.92z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 6,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 843.573,
    cy: 198.233,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 6,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 793.689,
    cy: 552.138,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 6,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 491.488,
    cy: 485.198,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 6,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 79.384,
    cy: 343.714,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 6,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 94.269,
    cy: 35.643,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 6,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 614.203,
    cy: 211.007,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b49be4",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    cx: 505.925,
    cy: 275.908,
    r: 5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "url(#a)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      InkscapeStroke: "none"
    },
    d: "M473.359 243.293h64.248v64.248h-64.248z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 505.483,
    cy: 275.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 505.483,
    cy: 263.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 505.483,
    cy: 287.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 517.483,
    cy: 275.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 517.483,
    cy: 263.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 517.483,
    cy: 287.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 493.483,
    cy: 275.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 493.483,
    cy: 263.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    cx: 493.483,
    cy: 287.417,
    r: 2.056
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M491.98 263.417h-10.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2.00006,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M491.04 275.414h-3.948l-6.09 6.094"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "url(#b)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M517.555 289.381v4.497l4.657 4.657M491.993 288.903l-9.263 9.262M518.972 276.81l4.574 2.642h5.938M505.58 261.347v-4.405l5.85-5.85M518.875 261.854l4.282-4.282v-6.457M506.976 276.508l4.413 2.548v19.456M504.573 288.368l-3.877 3.877v5.924"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      display: "inline",
      fill: "#5e34b2",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 5,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M473.36 235.793a7.5 7.5 0 0 0-7.5 7.5v64.248a7.5 7.5 0 0 0 7.5 7.5h64.247a7.5 7.5 0 0 0 7.5-7.5v-64.248a7.5 7.5 0 0 0-7.5-7.5zm7.5 15h12.311v-5 5h12.312v-5 5h12.312v-5 5h12.312v12.312h5-5v12.312h5-5v12.312h5-5v12.312h-12.312v5-5h-12.312v5-5h-12.312v5-5h-12.312v-12.312h-5 5v-12.312h-5 5v-12.312h-5 5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanHostingChipOptimized);
export default __webpack_public_path__ + "static/media/AmericanHosting-chip-optimized.f77aaff6324a7c984c2b19edde0eb1b3.svg";
export { ForwardRef as ReactComponent };